import { CartFragment } from '../../graphql/magento'
import { userCategories, UserCategory } from '../../utils/userClaims'
import { extractCartItemsMatching } from './restricted-items'
import { RestrictedItem } from './types'

/**
 * Spotlight test kits in the cart, in the shared RestrictedItem shape. Identified by SKU
 * (`isTestKitSku`) — cart items carry no category, so SKU is the only signal at the cart level.
 */
export const extractSpotlightKitItems = ({
  customerCart,
  isTestKitSku,
}: {
  customerCart: CartFragment
  isTestKitSku: (sku: string) => boolean
}): RestrictedItem[] =>
  extractCartItemsMatching({
    customerCart,
    matches: (sku) => !!sku && isTestKitSku(sku),
  })

/**
 * Block message: employees (the primary target) get the approved copy; other ineligible accounts
 * get an explanation of who may buy.
 */
export const spotlightBlockMessage = (userCategory: UserCategory | undefined): string =>
  userCategory === userCategories.employee
    ? 'Employee accounts cannot purchase Spotlight kits.'
    : 'This account is not eligible to purchase Spotlight kits. Spotlight kits require a practitioner account, or a patient account linked to a practitioner.'
